export function cn(...classes) {
  return classes
    .flatMap((c) => {
      if (!c) return [];
      if (typeof c === 'string') return [c];
      if (Array.isArray(c)) return c;
      if (typeof c === 'object') {
        return Object.keys(c).filter((key) => Boolean(c[key]));
      }
      return [];
    })
    .join(' ')
    .trim();
}

export const userStorage = {
  hasAccessToken: () => false,
  hasUserData: () => false,
  getUserData: () => null,
  getVendorName: () => null,
  updateSlug: () => {},
};

